import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { V_URL } from "../../../BaseUrl";
import Header from "../Include/Header";
import Sidebar from "../Include/Sidebar";
import Footer from "../Include/Footer";
import { getDepartment } from "../../../Store/Admin/Payroll/Department/Department";
import { adminGetParty } from "../../../Store/Admin/Party/GetParty";
import { getYear } from "../../../Store/Admin/Payroll/Year/Year";
import { getFirm } from "../../../Store/Admin/Firm/Firm";
import { getAuthPerson } from "../../../Store/Admin/Payroll/AuthPerson/AuthPerson";
import { AdminContractorMaster } from "../../../Store/Admin/Contractor/AdminContractorMaster";
import { getAdminProjectLocation } from "../../../Store/Admin/PMS/GetProjectLocation";
import { addStoreAuthPerson } from "../../../Store/Store/StoreMaster/AuthPerson/ManageAuthPerson";
import ManagerModal from "../../../Components/project/ManagerModal";
import DepartmentModal from "../../../Components/project/DepartmentModal";
import ClientModal from "../../../Components/project/ClientModal";
import { getAdminGroup } from "../../../Store/Admin/Payroll/Group/AdminGroup";
import { addDepartment } from "../../../Store/Admin/Payroll/Department/ManageDepartment";
import City from "../../../city.json";
import { adminGetPartyTag } from "../../../Store/Admin/PartyTag/AdminPartyTag";
import { adminGetPartyGroup } from "../../../Store/Admin/PartyTag/AdminPartyGroup";
import LocationModal from "../../../Components/project/LocationModal";
import ProjectForm from "../../../Components/project/ProjectForm";
import { addAuthPerson } from "../../../Store/Admin/Payroll/AuthPerson/ManageAuthPerson";
import ContractorModal from "../../../Components/project/ContractorModal";
import useFinancialYear from "../../../helper/getFinancialYear";

const ManageProject = () => {
  const [project, setProject] = useState({
    name: "",
    project_no: "",
    location: "",
    label: "",
    startDate: "",
    endDate: "",
    manager: "",
    department: "",
    party: "",
    details: "",
    firm: "",
    year: "",
    work_order_no: "",
    po_date: moment(Date.now()).format("YYYY-MM-DD"),
  });

  const [disable, setDisable] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [error, setError] = useState({});

  const [selectValue, setSelectValue] = useState("");
  const [isCompleted, setIsCompleted] = useState(false);
  const data = location.state;
  const dispatch = useDispatch();
  const [selectedCon, setSelectedCon] = useState([]);

  const [selectedState, setSelectedState] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [modal, setModal] = useState({
    manager: false,
    department: false,
    client: false,
    location: false,
    contractor: false,
  });

  // Manager Modal
  const [manager, setManager] = useState({
    name: "",
    error: "",
    disable: false,
  });

  // Location Modal
  const [locationDetails, setLocationDetails] = useState({
    name: "",
    error: "",
    disable: false,
  });

  // Department Modal
  const [department, setDepartment] = useState({
    name: "",
    group: "",
    error: {},
    disable: false,
  });

  // Client Modal
  const [client, setClient] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    address_two: "",
    address_three: "",
    pincode: "",
    req_no: "",
    pancard_no: "",
    contact_person: "",
    gst: "",
    error: {},
    disable: false,
  });

  const partyData = useSelector((state) => state?.adminGetParty?.user?.data);
  const getAdminPartyData = partyData?.filter(
    (p) => p?.is_admin === true && p.status === true
  );

  const departmentData = useSelector(
    (state) => state?.getDepartment?.user?.data
  );
  const managerData = useSelector((state) => state?.getAuthPerson?.user?.data);
  const yearData = useSelector((state) => state?.getYear?.user?.data);
  const firmData = useSelector((state) => state?.getFirm?.user?.data);
  const contractorData =
    useSelector((state) => state?.getAdminContractor?.user?.data) || [];
  const locationData =
    useSelector((state) => state?.getAdminProjectLocation?.user?.data) || [];

  const groupData = useSelector((state) => state.getAdminGroup?.user?.data);

  const financialYear = useFinancialYear();

  useEffect(() => {
    if (location.state) {
      setProject({
        name: location.state?.name,
        project_no: location.state?.project_no,
        location: location?.state?.location?._id,
        label: location?.state?.label,
        startDate: moment(location?.state?.startDate).format("YYYY-MM-DD"),
        endDate: moment(location?.state?.endDate).format("YYYY-MM-DD"),
        manager: location?.state?.projectManager?._id,
        department: location?.state?.department?._id,
        party: location?.state?.party?._id,
        details: location?.state?.details,
        firm: location.state.firm_id?._id,
        year: location.state.year_id?._id,
        work_order_no: location.state.work_order_no,
        po_date: location.state.po_date
          ? moment(location.state.po_date).format("YYYY-MM-DD")
          : null,
      });
      if (data?.contractor?.length > 0) {
        setSelectedCon(
          data?.contractor?.map((c) => ({
            conId: c?.conId?._id || c,
          }))
        );
      }
      setSelectValue(location.state.status);
      setIsCompleted(location.state.is_completed);
    }
  }, [location.state]);

  useEffect(() => {
    const fetchData = async (action) => {
      try {
        await dispatch(action());
      } catch (error) {
        console.error(error);
      }
    };

    fetchData(adminGetParty);
    fetchData(getDepartment);
    fetchData(getAuthPerson);
    fetchData(getYear);
    fetchData(getFirm);
    dispatch(getAdminProjectLocation({ status: true }));
    dispatch(AdminContractorMaster({ status: true }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(getAdminGroup());
  }, [dispatch]);

  useEffect(() => {
    if (!location.state && firmData?.length > 0) {
      setProject((prev) => ({ ...prev, firm: firmData[0]?._id }));
    }
  }, [firmData, location.state]);

  const openModal = (type) => setModal((prev) => ({ ...prev, [type]: true }));
  const closeModal = (type) => setModal((prev) => ({ ...prev, [type]: false }));

  const resetLocation = () =>
    setLocationDetails({ name: "", error: "", disable: false });
  const resetManager = () =>
    setManager({ name: "", error: "", disable: false });
  const resetDepartment = () =>
    setDepartment({ name: "", group: "", error: "", disable: false });

  const resetClient = () => {
    setClient({
      name: "",
      email: "",
      phone: "",
      address: "",
      address_two: "",
      address_three: "",
      state: "",
      city: "",
      pincode: "",
      req_no: "",
      pancard_no: "",
      gst: "",
      contact_person: "",
      error: {},
      disable: false,
    });
    setSelectedState("");
    setSelectedCity("");
  };

  const defaultCountry = City.find((c) => c.iso2 === "IN");
  const states = defaultCountry ? defaultCountry.states : [];
  const cities = states.find((s) => s.name === selectedState)?.cities || [];

  const handleLocationSubmit = () => {
    if (!locationDetails.name.trim()) {
      setLocationDetails((prev) => ({
        ...prev,
        error: "Please enter Location",
      }));
      return;
    }

    setLocationDetails((prev) => ({ ...prev, disable: true }));

    const bodyFormData = new URLSearchParams();
    bodyFormData.append("name", locationDetails.name.trim());

    axios({
      method: "post",
      url: `${V_URL}/admin/manage-project-location`,
      data: bodyFormData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${localStorage.getItem("VA_TOKEN")}`,
      },
    })
      .then((response) => {
        if (response.data.success === true) {
          toast.success(response.data.message);
          dispatch(getAdminProjectLocation({ status: true }));
          resetLocation();
          closeModal("location");
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        setLocationDetails((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleManagerSubmit = () => {
    if (!manager.name.trim()) {
      setManager((prev) => ({ ...prev, error: "Please enter manager name" }));
      return;
    }

    setManager((prev) => ({ ...prev, disable: true }));

    const bodyFormData = new URLSearchParams();
    bodyFormData.append("name", manager.name.trim());

    dispatch(addAuthPerson(bodyFormData))
      .then((res) => {
        if (res.payload?.success) {
          dispatch(getAuthPerson());
          closeModal("manager");
          resetManager();
        }
      })
      .catch((err) => {
        console.log(err);
        setManager((prev) => ({ ...prev, error: "Failed to add manager" }));
        closeModal("manager");
      })
      .finally(() => {
        setManager((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleDepartmentSubmit = () => {
    const newErrors = {};

    if (!department.name.trim()) {
      newErrors.name = "Please enter department name";
    }

    if (!department.group) {
      newErrors.group = "Please select department group";
    }

    if (Object.keys(newErrors).length > 0) {
      setDepartment((prev) => ({ ...prev, error: newErrors }));
      return;
    }

    setDepartment((prev) => ({ ...prev, error: {}, disable: true }));

    const bodyFormData = new URLSearchParams();
    bodyFormData.append("name", department.name.trim());
    bodyFormData.append("group", department.group);

    dispatch(addDepartment(bodyFormData))
      .then((res) => {
        if (res.payload?.success) {
          dispatch(getDepartment());

          closeModal("department");
          resetDepartment();
        }
      })
      .catch((err) => {
        console.log(err);
        closeModal("department");
      })
      .finally(() => {
        setManager((prev) => ({ ...prev, disable: false }));
      });
  };

  const handleStateChange = (e) => {
    const selectedState = e.target.value;
    setSelectedState(selectedState);
    setSelectedCity("");
    setClient((p) => ({ ...p, state: selectedState, city: "" }));
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setSelectedCity(selectedCity);
    setClient((p) => ({ ...p, city: selectedCity }));
  };

  const handleClientSubmit = async () => {
    const newErrors = {};

    if (!client.name.trim()) {
      newErrors.name = "Please enter name";
    }

    if (!client.address.trim()) {
      newErrors.address = "Please enter Address";
    }

    if (!selectedState.trim()) {
      newErrors.state = "Please enter state";
    }

    if (!selectedCity.trim()) {
      newErrors.city = "Please enter city";
    }
    if (!client.pincode.trim()) {
      newErrors.pincode = "Please enter pincode";
    }

    if (Object.keys(newErrors).length > 0) {
      setClient((prev) => ({ ...prev, error: newErrors }));
      return;
    }

    try {
      setClient((prev) => ({ ...prev, error: {}, disable: true }));

      const [tagRes, groupRes] = await Promise.all([
        axios.get(`${V_URL}/admin/get-party-tag`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("VA_TOKEN")}`,
          },
        }),
        axios.get(`${V_URL}/admin/get-party-group`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("VA_TOKEN")}`,
          },
        }),
      ]);

      const partyTag = tagRes?.data?.data?.find(
        (t) => t.name?.toLowerCase() === "party"
      );
      const partyGroup = groupRes?.data?.data?.find(
        (g) => g.name?.toLowerCase() === "client"
      );

      const formData = new URLSearchParams();
      formData.append("name", client.name);
      formData.append("email", client.email);
      formData.append("phone", client.phone);
      formData.append("address", client.address);
      formData.append("address_two", client.address_two);
      formData.append("address_three", client.address_three);
      formData.append("state", selectedState);
      formData.append("city", selectedCity);
      formData.append("pincode", client.pincode);
      formData.append("req_no", client.req_no);
      formData.append("pancard_no", client.pancard_no);
      formData.append("gstNumber", client.gst);
      formData.append("partyGroup", partyGroup?._id);
      formData.append("party_tag_id", partyTag?._id);
      formData.append("auth_person_id", client.contact_person);
      formData.append("is_admin", true);

      const response = await axios.post(
        `${V_URL}/admin/manage-party`,
        formData,
        {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${localStorage.getItem("VA_TOKEN")}`,
          },
        }
      );

      if (response?.data?.success) {
        toast.success(response.data.message);
        dispatch(adminGetParty());
        closeModal("client");
        resetClient();
      } else {
        toast.error(response?.data?.message || "Something went wrong");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setClient((prev) => ({ ...prev, disable: false }));
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        await Promise?.all([
          dispatch(adminGetPartyTag()),
          dispatch(adminGetPartyGroup()),
        ]);
      } catch (error) {
        console.log(error, "!!");
      }
    };

    fetchInitialData();
  }, [dispatch]);

  const handleRadioChange = (event) => {
    setSelectValue(event.target.checked);
  };

  const handleCompletedRadio = (event) => {
    setIsCompleted(event.target.checked);
  };

  const handleChange = (e) => {
    setProject({ ...project, [e.target.name]: e.target.value });
  };

  const handleEditFormChange = (event) => {
    const value = event.target.value;
    const formatted = value.map((id) => (id));
    setSelectedCon(formatted);
  };

  useEffect(() => {
    if (!location.state && financialYear?.id) {
      setProject((prev) => ({
        ...prev,
        year: financialYear.id,
      }));
    }
  }, [financialYear?.id, location.state]);

  const handleSubmit = () => {
    if (validation()) {
      setDisable(true);

      const bodyFormData = new URLSearchParams();
      bodyFormData.append("firm_id", project.firm);
      bodyFormData.append("year_id", project.year);

      bodyFormData.append("name", project.name);
      bodyFormData.append("project_no", project.project_no);
      bodyFormData.append("location", project.location);
      bodyFormData.append("label", project.label);
      bodyFormData.append("startDate", project.startDate);
      bodyFormData.append("endDate", project.endDate);
      bodyFormData.append("projectManager", project.manager);
      bodyFormData.append("department", project.department);
      bodyFormData.append("party", project.party);
      bodyFormData.append("details", project.details);
      bodyFormData.append("work_order_no", project.work_order_no);
      bodyFormData.append("contractor", JSON.stringify(selectedCon));
      bodyFormData.append("is_completed", isCompleted);

      bodyFormData.append("po_date", project.po_date);

      if (data?._id) {
        bodyFormData.append("id", data?._id);
        bodyFormData.append("status", selectValue);
      }

      axios({
        method: "post",
        url: `${V_URL}/admin/manage-project`,
        data: bodyFormData,
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: "Bearer " + localStorage.getItem("VA_TOKEN"),
        },
      })
        .then((response) => {
          if (response.data.success === true) {
            toast.success(response.data.message);
            navigate("/admin/project-management");
            handleReset();
            setDisable(false);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message);
          setDisable(false);
        });
    }
  };

  const handleReset = () => {
    setProject({
      name: "",
      project_no: "",
      location: "",
      label: "",
      startDate: "",
      endDate: "",
      manager: "",
      department: "",
      party: "",
      details: "",
      firm: "",
      year: "",
      work_order_no: "",
      contractor: [],
      po_date: moment(Date.now()).format("YYYY-MM-DD"),
    });
  };

  const validation = () => {
    let isValid = true;
    let err = {};

    if (!project.name || !project?.name?.trim()) {
      isValid = false;
      err["name_err"] = "Please enter name";
    }
    if (!project.project_no || !project?.project_no?.trim()) {
      isValid = false;
      err["project_no_err"] = "Please enter Project number";
    }
    if (!project.firm) {
      isValid = false;
      err["firm_err"] = "Please select firm";
    }
    if (!project.location || !project.location.trim()) {
      isValid = false;
      err["location_err"] = "Please enter location";
    }

    if (!project.label || !project.label.trim()) {
      isValid = false;
      err["label_err"] = "Please enter label";
    }
    if (!project.manager) {
      isValid = false;
      err["manager_err"] = "Please select manager";
    }

    if (!project.party) {
      isValid = false;
      err["party_err"] = "Please select Client";
    }

    if (!project.details || !project?.details?.trim()) {
      isValid = false;
      err["detail_err"] = "Please enter detail";
    }

    if (!project.work_order_no || !project?.work_order_no?.trim()) {
      isValid = false;
      err["work_order_no_err"] = "Please enter work order no.";
    }

    if (!project.po_date) {
      isValid = false;
      err["po_date_err"] = "Please select po date";
    }
    setError(err);
    return isValid;
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const handleOpen = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  useEffect(() => {
    setTimeout(() => {
      const tooltipTriggerList = document.querySelectorAll(
        '[data-bs-toggle="tooltip"]'
      );
      tooltipTriggerList.forEach((tooltipTriggerEl) => {
        new window.bootstrap.Tooltip(tooltipTriggerEl);
      });
    }, 0);
  }, []);

  return (
    <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
      <Header handleOpen={handleOpen} />
      <Sidebar />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard">Dashboard </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/admin/project-management">Project </Link>
                  </li>
                  <li className="breadcrumb-item">
                    <i className="feather-chevron-right"></i>
                  </li>
                  <li className="breadcrumb-item active">
                    {data?._id ? "Edit" : "Add"} Project
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <ProjectForm
                    project={project}
                    handleChange={handleChange}
                    error={error}
                    data={data}
                    firmData={firmData}
                    locationData={locationData}
                    managerData={managerData}
                    departmentData={departmentData}
                    getAdminPartyData={getAdminPartyData}
                    contractorData={contractorData}
                    isCompleted={isCompleted}
                    handleCompletedRadio={handleCompletedRadio}
                    selectValue={selectValue}
                    handleRadioChange={handleRadioChange}
                    openModal={openModal}
                    selectedCon={selectedCon}
                    handleEditFormChange={handleEditFormChange}
                  />

                  <div className="col-12">
                    <div className="doctor-submit text-end">
                      <button
                        type="button"
                        className="btn btn-primary submit-form me-2"
                        onClick={handleSubmit}
                        disabled={disable}
                      >
                        {disable
                          ? "Processing..."
                          : data?._id
                            ? "Update"
                            : "Submit"}
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary cancel-form"
                        onClick={handleReset}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>

      <ContractorModal
        show={modal.contractor}
        onClose={() => closeModal("contractor")}
        onContractorCreated={(newContractor) => {
          dispatch(AdminContractorMaster({ status: true }));

          if (newContractor?._id) {
            setSelectedCon((prev) => [...prev, { conId: newContractor._id }]);
          }

          closeModal("contractor");
        }}
      />

      <DepartmentModal
        show={modal.department}
        onClose={() => {
          closeModal("department");
          resetDepartment();
        }}
        departmentName={department.name}
        setDepartmentName={(v) =>
          setDepartment((prev) => ({
            ...prev,
            name: v,
            error: { ...prev.error, name: "" },
          }))
        }
        group={department.group}
        setGroup={(v) =>
          setDepartment((prev) => ({
            ...prev,
            group: v,
            error: { ...prev.error, group: "" },
          }))
        }
        groupData={groupData}
        error={department.error}
        handleSubmit={handleDepartmentSubmit}
        disableSubmit={department.disable}
      />

      <ClientModal
        show={modal.client}
        onClose={() => {
          closeModal("client");
          resetClient();
        }}
        form={client}
        setForm={(field, value) => setClient((p) => ({ ...p, [field]: value }))}
        clientError={client.error}
        states={states}
        cities={cities}
        handleStateChange={handleStateChange}
        handleCityChange={handleCityChange}
        onSubmit={handleClientSubmit}
        authData={managerData}
        disableSubmit={client.disable}
      />

      <LocationModal
        show={modal.location}
        onClose={() => {
          closeModal("location");
          resetLocation();
        }}
        locationName={locationDetails.name}
        setLocationDetails={(location) => {
          setLocationDetails((p) => ({ ...p, name: location, error: "" }));
        }}
        locationError={locationDetails.error}
        onSubmit={handleLocationSubmit}
        disableSubmit={locationDetails.disable}
      />

      <ManagerModal
        show={modal.manager}
        onClose={() => {
          closeModal("manager");
          resetManager();
        }}
        managerName={manager.name}
        setManagerName={(v) =>
          setManager((p) => ({ ...p, name: v, error: "" }))
        }
        managerModalError={manager.error}
        onSubmit={handleManagerSubmit}
        disableSubmit={manager.disable}
      />
    </div>
  );
};

export default ManageProject;
